import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.string.replace-all.js";
import topTitle from '@/components/title';
import quillConfig from '@/views/components/editor/quill-config.js';
import { unitResource } from './../../underwritingManage/request';
import { intermediaryResource } from './../../agencyManage/request';
import { agencyResource } from './../../organizationalManage/request';
import { insuranceClassResource } from './../../classManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { addMainInfov2, mainDetailV2, editMainInfo, insuranceReminder } from '../request';
export default {
  props: ['id', 'info'],
  components: {
    topTitle
    // tinymce
  },
  data() {
    return {
      show: false,
      form1: {},
      quillOption: quillConfig,
      form: {
        unitId: undefined,
        //承保单位ID
        agencyId: undefined,
        //机构ID
        intermediaryId: undefined,
        //中介机构ID
        sortId: undefined,
        name2: {
          //产品名称
          name: '',
          isEdit: false
        },
        echoName: '',
        content: '',
        object: 0
      },
      unitList: [],
      intermediaryList: [],
      agencyList: [],
      additionalList: [],
      insuranceClassList: [],
      templateData: [],
      insuranceReminder: ''
    };
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    insuranceClassResource({}).then(res => {
      this.insuranceClassList = res.items;
    });
    this.agencyFun();
  },
  async mounted() {
    if (this.info.id) {
      this.form = this.info;
      this.form.intermediaryId = this.info.intermediaryId == 0 ? undefined : this.info.intermediaryId;
      this.form.name2 = this.info.name;
      // debugger;
      let newDetail = await mainDetailV2({
        insuranceId: this.id
      });
      this.form.content = newDetail.reminder.content;
      this.form.echoName = newDetail.echoName;
      await this.agencyFun2();
      await this.getReminder(this.info.agencyId, 'first');
    }
  },
  computed: {
    dataRule() {
      return {
        unitId: [{
          required: true,
          message: this.$t('请选择') + this.$t('承保单位'),
          trigger: 'change'
        }],
        agencyId: [{
          required: true,
          message: this.$t('请选择') + this.$t('机构'),
          trigger: 'change'
        }],
        sortId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品大类'),
          trigger: 'change'
        }],
        underwriteArea: [{
          required: true,
          message: this.$t('请输入') + this.$t('承保区域'),
          trigger: 'blur'
        }, {
          message: '2-100' + this.$t('字符'),
          max: 100,
          min: 2
        }],
        effective: [{
          required: true,
          validator: this.validateEffective,
          trigger: 'blur'
        }],
        servings: [{
          required: true,
          trigger: 'change',
          message: this.$t('请输入') + this.$t('投保份数')
        }, {
          min: 1,
          max: 10,
          message: this.$t('请输入') + this.$t('1-10范围内数值'),
          trigger: 'change',
          type: 'number'
        }],
        isTimely: [{
          required: true,
          message: this.$t('请选择') + this.$t('出单模式'),
          trigger: 'change'
        }],
        isRenewal: [{
          required: true,
          message: this.$t('请选择') + this.$t('是否自动续保'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          validator: this.validateName,
          trigger: 'blur'
        }],
        content: [{
          required: true,
          validator: this.validateContent,
          trigger: 'change'
        }],
        echoName: [{
          required: true,
          message: this.$t('请选择') + this.$t('回显名称'),
          trigger: 'change'
        }],
        code: [{
          required: false,
          max: 30,
          message: this.$t('最多输入') + '30' + this.$t('字符'),
          trigger: 'change'
        }],
        recordNumber: [{
          required: false,
          max: 50,
          message: this.$t('最多输入') + '50' + this.$t('字符'),
          trigger: 'change'
        }],
        recordName: [{
          required: false,
          max: 50,
          message: this.$t('最多输入') + '50' + this.$t('字符'),
          trigger: 'change'
        }],
        remark: [{
          required: false,
          max: 100,
          message: this.$t('最多输入') + '100' + this.$t('字符'),
          trigger: 'change'
        }],
        price: [{
          required: false,
          trigger: 'blur',
          validator: this.validatePrice
        }]
      };
    }
  },
  methods: {
    validatePrice(rule, value, callback) {
      if (String(value).charAt(0) == '.') {
        callback(new Error(this.$t('小数点不能为第一位')));
      } else if (String(value).indexOf('.') > -1) {
        if (String(value).split('.').length != 2) {
          callback(new Error(this.$t('只能拥有一个小数点')));
        } else if (String(value).split('.')[1].length > 2) {
          callback(new Error(this.$t('小数点之后保留两位')));
        } else if (String(value).split('.')[1].length == 0) {
          callback(new Error(this.$t('小数点之后必须有一位')));
        } else if (Number(value) > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      } else if (Number(value) > 40000000) {
        callback(new Error(this.$t('不能大于40000000')));
      } else {
        callback();
      }
    },
    validateName(rule, value, callback) {
      if (!this.form.name2.name) {
        callback(new Error(this.$t('请输入') + this.$t('产品名称')));
      } else {
        if (this.form.name2.name.length < 5) {
          callback(new Error(this.$t('至少输入') + '5' + this.$t('字符')));
        } else if (this.form.name2.name.length > 50) {
          callback(new Error(this.$t('最多输入') + '50' + this.$t('字符')));
        } else {
          callback();
        }
      }
    },
    // const validateServings = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请输入投保份数'));
    //   } else {
    //     if (Number(value < 1 || Number(value) > 10)) {
    //       callback(new Error('请输入1-10范围内数值'));
    //     }
    //     callback();
    //   }
    // };
    validateContent(rule, value, callback) {
      if (!this.form.content) {
        // 当前保险机构暂未无投保提醒
        this.show = true;
        callback(new Error(' '));
      } else {
        this.show = false;
        callback();
      }
    },
    validateEffective(rule, value, callback) {
      if (!this.form.effective && this.form.effective !== 0) {
        callback(new Error(this.$t('请输入0-180范围内整数值')));
      } else {
        if (Number(this.form.effective) > 180 || Number(this.form.effective < 0)) {
          callback(new Error(this.$t('请输入0-180范围内整数值')));
        }
        callback();
      }
    },
    changeRadio(e) {
      this.form.content = this.changeReminder(this.templateData, this.insuranceReminder, e.target.value);
    },
    async getReminder(a, key) {
      this.show = false;
      if (!a) {
        this.form.unitId = undefined;
        return false;
      }
      const res = await insuranceReminder({
        agencyId: a
      });
      this.insuranceReminder = recursionCopy(res.insuranceReminder);
      this.templateData = Object.entries(res.documentName);
      if (!this.form.content) {
        this.form.content = res.insuranceReminder;
      }
      if (!this.form.echoName) {
        this.form.echoName = 'VARIABLE_TYPE';
      }
      if (key == 'first') {
        let type;
        if (this.form.echoName) {
          type = this.form.echoName === 'VARIABLE_TYPE' ? 0 : 1;
        } else {
          type = 0;
        }
        this.templateData.map(i => {
          if (this.form.content.includes(i[type])) {
            this.form.content = this.form.content.replaceAll(i[type], `<span style="color:#1890ff">${i[type]}</span>`);
          }
        });
      } else {
        // debugger;
        this.form.content = this.changeReminder(this.templateData, res.insuranceReminder, 'VARIABLE_TYPE');
      }
      this.$set(this.form, this.form.content, this.form.content);
      if (!this.form.content) {
        this.form.echoName = undefined;
        this.form.content = '';
      } else {
        if (key != 'first') {
          this.form.echoName = 'VARIABLE_TYPE';
        }
        this.form.content = this.changeReminder(this.templateData, recursionCopy(res.insuranceReminder), this.form.echoName);
        this.$set(this.form, this.form.content, this.form.content);
      }
      if (!this.form.content) {
        this.$refs.reminderRef.onFieldChange();
      }
      if (!this.$store.state.user.accountInfo.customerId && a) {
        await this.countryAndCurrencyInfo(this.form.agencyId, 'agencyId');
      }
    },
    changeReminder(data, name, type) {
      data.map(i => {
        if (name.includes(i[0])) {
          if (type === 'VARIABLE_TYPE') {
            name = name.replaceAll(i[0], `<span style="color:#1890ff">${i[0]}</span>`);
          } else {
            name = name.replaceAll(i[0], `<span style="color:#1890ff">${i[1]}</span>`);
          }
        }
      });
      return this.$t(name);
    },
    nextFun() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.form.name = JSON.stringify(this.form.name2);
          let fun = this.id == -1 ? addMainInfov2 : editMainInfo;
          this.form.insuranceId = this.id == -1 ? -1 : this.id;
          fun(this.form).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('next', res);
          });
          // this.$emit('next', 1);
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    agencyFun() {
      intermediaryResource({
        type: 0
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    dataFormChange(type) {
      this.form[type] = String(this.form[type]).replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.');
    },
    async onChange() {
      this.agencyList = [];
      this.form.agencyId = undefined;
      await this.agencyFun2();
    },
    async agencyFun2() {
      const res = await agencyResource({
        unitId: this.form.unitId
      });
      this.agencyList = res;
    }
  }
};